import { TableBody } from '@mui/material'
import { ReactElement } from 'react'
import Row from './Row'
import { Part } from '../../../Common/interfaces'
import { observer } from 'mobx-react-lite'

interface TableProps {
  rows: Part[]
}

const Body = observer((props: TableProps): ReactElement => {
  const { rows } = props
  return (
    <TableBody>
      {rows?.map((row, index) => (
        <Row key={`review_add_part_row_${index}`} {...row} />
      ))}
    </TableBody>
  )
})

export default Body
